module.exports = __webpack_public_path__ + "static/media/aguaDeLuz.9b408237.png";